import { useEffect, useState } from "react";
import { type IEntidadesRegistroTarea, type IModalTareaCVProps } from "../interfaces";
import { TareaModelo } from "../../../modelos/Tarea";
import { useNotificaciones } from "../../../globales/contextos/notificationContext";
import { EnumTipoNotificacion } from "../../../globales/interfaces";
import ModalTareaVista from "../vista/modalTareaVista";
import ModeloUsuario from "../../../modelos/Usuario";
import { ClienteModelo } from "../../../modelos/Clientes";
import { TipoTareaModelo } from "../../../modelos/TipoTarea";
import { ModuloModelo } from "../../../modelos/ModulosCheckList";
import { EnumPerfiles } from "../../../globales/enums/enumPerfiles";
import { ContratoModelo } from "../../../modelos/Contratos";
import { EquipoModelo } from "../../../modelos/Equipo";
import { estadoInicialFiltroProyecto } from "../../proyectos/interfaces";
import { EnumTipoTarea } from "../enums/enumTipoTarea";
import { EnumEstadoTarea } from "../enums/enumEstadoTarea";
import ModeloCausalEmergencia from "../../../modelos/CausalEmergencia";
import { EnumEstadoEquipo } from "../../equipos/enums/enumEstadoEquipo";
import { EnumTipoEquipo } from "../../equipos/enums/enumTipoEquipo";
import { estadoInicialFiltroUsuario } from "../../usuarios/interfaces";
import type { ITareaFormulario } from "../interfaces/ITareaFormulario";
import { convertirFormularioATarea } from "../utils/tareaUtils";
import { estadoInicialFiltroCliente } from "../../clientes/interfaces";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { obtenerZonaHorariaPorPais, obtenerNombrePaisPorId } from "../utils/zonaHorariaUtils";
import { ModuloTareaModelo } from "../../../modelos/ModulosTarea";

dayjs.extend(utc);
dayjs.extend(timezone);
import { useConfirmacion } from "../../../globales/contextos/confirmacionContext";
import { ProyectoModelo } from "../../../modelos/Proyectos";
import { useCargando } from "../../../globales/contextos/cargandoContext";
import type { IModulo } from "../../../modelos/ModulosCheckList/entidades/IModulo";
import { useAutenticacion } from "../../../globales/contextos/authContext";

const ModalTareaCV: React.FunctionComponent<IModalTareaCVProps> = ({
    consultarTareas,
    abrirModalTarea,
    estadoModal,
    entidadTarea,
    setEntidadTarea,
    visualizacion,
    esEmergencia,
    entidadesRegistro
}) => {
    const modeloTarea = new TareaModelo();
    const modeloProyecto = new ProyectoModelo();
    const modeloEquipo = new EquipoModelo();
    const modeloUsuario = new ModeloUsuario();
    const modeloCliente = new ClienteModelo();
    const modeloTipoTarea = new TipoTareaModelo();
    const modeloModulo = new ModuloModelo();
    const modeloContrato = new ContratoModelo();
    const modeloCausalEmergencia = new ModeloCausalEmergencia();
    const modeloModuloTarea = new ModuloTareaModelo();

    const { mostrarNotificacion } = useNotificaciones();
    const { manejarCargando } = useCargando();
    const { usuario } = useAutenticacion();
    const { confirmar } = useConfirmacion();
    const [errores, setErrores] = useState<Partial<Record<keyof ITareaFormulario, string | null>>>({});
    const [entidadesTarea, setEntidadesTarea] = useState<IEntidadesRegistroTarea>(entidadesRegistro || {
        Equipos: [],
        EquiposTodos: [],
        Proyectos: [],
        ProyectosTodos: [],
        Tecnicos: [],
        TecnicosTodos: [],
        TiposTarea: [],
        ModulosCheckList: [],
        ModulosCheckListTodos: [],
        Clientes: [],
        ClientesTodos: [],
        EstadosTarea: [],
        CausalesEmergencia: [],
        Paises: []
    });

    useEffect(() => {
        if (entidadesRegistro) {
            // Sincronizar catálogos generales desde el padre si existen
            setEntidadesTarea(prev => ({
                ...prev,
                ...entidadesRegistro,
                // Respetar catálogos que se manejan localmente en el modal si es necesario
                Equipos: prev.Equipos.length > 0 ? prev.Equipos : entidadesRegistro.Equipos,
                ModulosCheckList: prev.ModulosCheckList.length > 0 ? prev.ModulosCheckList : entidadesRegistro.ModulosCheckList,
            }));
        }
    }, [entidadesRegistro]);

    const [fechaOriginal, setFechaOriginal] = useState<string | null>(null);


    console.log(
        "Tipo",
        entidadTarea.TipoServicioId,
        "Modulos",
        entidadesTarea.ModulosCheckList
    );
    useEffect(() => {
        if (!estadoModal) {
            setErrores({})
            setEntidadesTarea({
                ...entidadesTarea,
                Equipos: [],
                EquiposTodos: []
            })
            setFechaOriginal(null); // Limpiar al cerrar
        } else {
            consultarEntidadesRegistro();
            if (entidadTarea.Id) {
                setFechaOriginal(entidadTarea.FechaInicio); // Guardar fecha inicial al abrir edición
            }
        }
    }, [estadoModal])



    useEffect(() => {
        if (esEmergencia) {
            setEntidadTarea({
                ...entidadTarea,
                TipoServicioId: EnumTipoTarea.Emergencia,
                ModulosChecklist: entidadesTarea.ModulosCheckListTodos.filter(m => m.Codigo.toLowerCase() === 'emergencia').map(m => m.Id)
            })
        }

    }, [esEmergencia, entidadesTarea.TiposTarea, estadoModal])

    // ✅ NUEVO useEffect para manejar cambios en TipoServicioId
    useEffect(() => {

        if (entidadTarea.TipoServicioId === EnumTipoTarea.Emergencia) {
            // Si es emergencia, mostrar SOLO los módulos de emergencia
            const modulosEmergencia = entidadesTarea.ModulosCheckListTodos
                .filter(m => m.Codigo.toLowerCase() === 'emergencia');

            setEntidadesTarea(prev => ({
                ...prev,
                ModulosCheckList: modulosEmergencia
            }));
        } else if (entidadTarea.TipoServicioId === EnumTipoTarea.Correctivo || entidadTarea.TipoServicioId === EnumTipoTarea.Acompanamiento) {
            // Si es correctivo, mostrar SOLO los módulos de cliente
            const modulosCliente = entidadesTarea.ModulosCheckListTodos
                .filter(m => m.Codigo === 'MODULO_CLIENTE');

            setEntidadesTarea(prev => ({
                ...prev,
                ModulosCheckList: modulosCliente
            }));
        }

    }, [entidadTarea.TipoServicioId]);

    // ✅ NUEVO useEffect para ajustar el valor inicial de la fecha basado en el proyecto seleccionado
    useEffect(() => {
        if (!entidadTarea.Id && entidadTarea.ProyectoId !== 0 && entidadesTarea.Proyectos.length > 0) {
            const proyecto = entidadesTarea.Proyectos.find(p => p.Id === entidadTarea.ProyectoId);
            const timezoneProyecto = obtenerZonaHorariaPorPais(proyecto?.PaisId);
            const fechaInicioProyecto = dayjs().tz(timezoneProyecto).format("YYYY-MM-DDTHH:mm:ss");

            setEntidadTarea(prev => ({
                ...prev,
                FechaInicio: fechaInicioProyecto,
                FechaFin: prev.Duracion ? dayjs(fechaInicioProyecto).add(prev.Duracion, 'minutes').format("YYYY-MM-DDTHH:mm:ss") : fechaInicioProyecto
            }));
        }
    }, [entidadTarea.ProyectoId, entidadesTarea.Proyectos]);

    useEffect(() => {

        if (!entidadTarea.TipoServicioId) return;
        if (!entidadTarea.CodigoEquipo) return;

        // ✅ Si es emergencia o correctivo, no hacer el filtro por equipo
        if (entidadTarea.TipoServicioId === EnumTipoTarea.Emergencia || entidadTarea.TipoServicioId === EnumTipoTarea.Correctivo || entidadTarea.TipoServicioId === EnumTipoTarea.Acompanamiento) return;

        const cargarModulos = async () => {

            const equipoRes = await modeloEquipo.obtenerListaEquipos({
                Codigo: entidadTarea.CodigoEquipo
            });

            const tipoEquipoId =
                equipoRes.Data?.[0]?.TipoEquipoId === EnumTipoEquipo.Rampa
                    ? EnumTipoEquipo.Escalera
                    : equipoRes.Data?.[0]?.TipoEquipoId;

            const modulosFiltrados = entidadesTarea.ModulosCheckListTodos.filter(modulo => {

                if (modulo.Codigo === 'EMERGENCIA') return false;

                const esModuloCliente = modulo.Codigo === 'MODULO_CLIENTE';
                const coincideEquipo = modulo.TipoEquipo === tipoEquipoId;

                return esModuloCliente || coincideEquipo;

            });

            setEntidadesTarea(prev => ({
                ...prev,
                ModulosCheckList: modulosFiltrados
            }));

        };

        cargarModulos();

    }, [
        entidadTarea.TipoServicioId,
        entidadTarea.CodigoEquipo
    ]);

    const consultarEntidadesRegistro = async () => {
        try {
            manejarCargando(true, undefined, true);
            const [clientes, proyectos, tiposTarea, tecnicos, modulos, causalesEmergencia] = await Promise.all([
                modeloCliente.obtenerListaClientes(estadoInicialFiltroCliente),
                modeloProyecto.obtenerListaProyectos(estadoInicialFiltroProyecto.NitProyecto),
                modeloTipoTarea.obtenerListaTiposTarea(),
                modeloUsuario.obtenerListaUsuarios(estadoInicialFiltroUsuario),
                modeloModulo.obtenerListaModulos(),
                modeloCausalEmergencia.obtenerListaCausalesEmergencia()
            ]);

            const idsClientesSet = new Set(
                proyectos.Data
                    .map(p => p.ClienteId)
                    .filter((id): id is number => id !== null)
            );

            // Filtramos y eliminamos duplicados por Id
            const clientesFiltrados = Array.from(
                new Map(
                    clientes.Data
                        .filter(c => idsClientesSet.has(c.Id))
                        .map(c => [c.Id, c]) // clave -> Id del cliente
                ).values()
            );

            let modulosFiltrados: IModulo[] = modulos.Data.Modulos;

            if (entidadTarea.Id && entidadTarea.Equipo && entidadTarea.Equipo.TipoEquipoId && entidadTarea.TipoServicioId !== EnumTipoTarea.Emergencia && entidadTarea.TipoServicioId !== EnumTipoTarea.Correctivo && entidadTarea.TipoServicioId !== EnumTipoTarea.Acompanamiento) {
                // 1. Definimos qué equipo estamos buscando
                const tipoEquipoRelacionados = entidadTarea.Equipo.TipoEquipoId === EnumTipoEquipo.Rampa
                    ? EnumTipoEquipo.Escalera
                    : entidadTarea.Equipo.TipoEquipoId;

                // 2. Aplicamos el filtro inteligente
                modulosFiltrados = entidadesTarea.ModulosCheckListTodos.filter(modulo => {
                    // REGLA 1: Si es el módulo de EMERGENCIA, nunca se debe listar (false)
                    // Cambia 'Emergencia' por el ID o nombre exacto que tenga en tu base de datos
                    if (modulo.Codigo === 'EMERGENCIA') {
                        return false;
                    }

                    // REGLA 2: Si es el módulo de CLIENTE, siempre se debe listar (true)
                    const esModuloCliente = modulo.Codigo === 'MODULO_CLIENTE';

                    // REGLA 3: Si coincide con el tipo de equipo seleccionado (true)
                    const coincideConEquipo = modulo.TipoEquipo === tipoEquipoRelacionados;

                    return esModuloCliente || coincideConEquipo;
                });
            }

            // Filtrar técnicos por regional si ya hay un proyecto seleccionado (ej: edición)
            let tecnicosFiltrados = tecnicos.Data.filter(u => u.PerfilUsuarioId === EnumPerfiles.Tecnico && u.Activo);
            if (entidadTarea.ProyectoId && entidadTarea.ProyectoId !== 0) {
                const proyectoActivo = proyectos.Data.find(p => p.Id === entidadTarea.ProyectoId);
                if (proyectoActivo && proyectoActivo.Regional) {
                    tecnicosFiltrados = tecnicosFiltrados.filter(t => t.RegionalId === proyectoActivo.Regional?.Id);
                }
            }

            setEntidadesTarea({
                Proyectos: proyectos.Data.filter(p => p.Activo && p.Eliminado === false),
                ProyectosTodos: proyectos.Data.filter(p => p.Activo && p.Eliminado === false),
                Clientes: clientesFiltrados,
                ClientesTodos: clientesFiltrados,
                Tecnicos: tecnicosFiltrados,
                TecnicosTodos: tecnicos.Data.filter(u => u.PerfilUsuarioId === EnumPerfiles.Tecnico && u.Activo),
                Equipos: [],
                EquiposTodos: [],
                TiposTarea: tiposTarea.Data,
                ModulosCheckList: modulosFiltrados,
                ModulosCheckListTodos: modulos.Data.Modulos,
                EstadosTarea: [],
                CausalesEmergencia: causalesEmergencia.Data,
                Paises: []
            });

        } catch {
            mostrarNotificacion(
                EnumTipoNotificacion.Error,
                'Error al cargar datos de catalogos',
                'No fue posible cargar los datos necesarios para los catalogos. Por favor verifica tu conexión e intenta nuevamente.',
                5000
            );
        } finally {
            manejarCargando(false);
        }
    }

    const validarCamposTarea = (edicion: boolean) => {
        let esValido = true;
        let fechaValida = true;
        let validacionTipoEquipoTipoTarea = true;
        let validacionPerfilUsuarioLoggeado = true

        // Obtenemos el timezone del proyecto seleccionado
        const proyectoSeleccionado = entidadesTarea.Proyectos.find(p => p.Id === entidadTarea.ProyectoId);
        const timezoneProyecto = obtenerZonaHorariaPorPais(proyectoSeleccionado?.PaisId);
        const nombrePais = obtenerNombrePaisPorId(proyectoSeleccionado?.PaisId);

        // Calculamos 'ahora' usando el timezone del proyecto (generando un string y analizándolo localmente)
        const ahoraString = dayjs().tz(timezoneProyecto).format("YYYY-MM-DDTHH:mm:ss");
        const ahora = dayjs(ahoraString);

        // La fecha seleccionada representa la hora local en el contexto del proyecto
        const inicio = dayjs(entidadTarea.FechaInicio);

        if (!inicio.isValid()) {
            agregarError("FechaInicio", "La fecha de inicio no es válida");
            fechaValida = false;
        } else {
            // Caso 1: Nueva Tarea (No tiene ID) -> Siempre validar contra hoy
            if (!edicion) {
                if (inicio.isBefore(ahora, 'day')) {
                    agregarError("FechaInicio", `La fecha de inicio debe ser mayor o igual a la fecha actual en ${nombrePais}`);
                    fechaValida = false;
                } else if (inicio.isSame(ahora, 'day') && inicio.isBefore(ahora, 'minute')) {
                    agregarError("FechaInicio", `La hora de inicio no puede ser anterior a la hora actual en ${nombrePais}`);
                    fechaValida = false;
                } else {
                    agregarError("FechaInicio", "");
                    fechaValida = true;
                }
            } 
            // Caso 2: Edición -> Solo validar si la fecha cambió respecto a la original
            else {
                const cambioFecha = entidadTarea.FechaInicio !== fechaOriginal;
                
                if (cambioFecha) {
                    if (inicio.isBefore(ahora, 'day')) {
                        agregarError("FechaInicio", `Si vas a cambiar la fecha, debe ser mayor o igual a la fecha actual en ${nombrePais}`);
                        fechaValida = false;
                    } else if (inicio.isSame(ahora, 'day') && inicio.isBefore(ahora, 'minute')) {
                        agregarError("FechaInicio", `La hora de inicio no puede ser anterior a la hora actual en ${nombrePais}`);
                        fechaValida = false;
                    } else {
                        agregarError("FechaInicio", "");
                        fechaValida = true;
                    }
                } else {
                    // Si no cambió, es válida aunque sea del pasado (para no bloquear edición de otros campos)
                    agregarError("FechaInicio", "");
                    fechaValida = true;
                }
            }
        }


        if (entidadTarea.ProyectoId === 0) {
            agregarError("ProyectoId", "Selecciona un proyecto");
            esValido = false;
        }

        if (entidadTarea.ClienteId === 0) {
            agregarError("ClienteId", "Este campo es requerido");
            esValido = false;
        }

        if (entidadTarea.EquipoId === 0) {
            agregarError("EquipoId", "Este campo es requerido");
            esValido = false;
        }

        if (entidadTarea.NumeroContrato === '') {
            agregarError("NumeroContrato", "Este campo es requerido");
            esValido = false;
        }

        if (entidadTarea.TipoServicioId === 0) {
            agregarError("TipoServicioId", "Selecciona un tipo");
            esValido = false;
        }

        if (entidadTarea.AsignadaA === 0) {
            agregarError("AsignadaA", "Selecciona un técnico");
            esValido = false;
        }

        if (entidadTarea.Duracion === 0) {
            agregarError("Duracion", "Este campo es requerido");
            esValido = false;
        }

        if (entidadTarea.ModulosChecklist && entidadTarea.ModulosChecklist.length === 0 && entidadTarea.TipoServicioId !== EnumTipoTarea.Emergencia && entidadTarea.TipoServicioId !== EnumTipoTarea.Correctivo && entidadTarea.TipoServicioId !== EnumTipoTarea.Acompanamiento) {
            agregarError("ModulosChecklist", "Selecciona minimo un modulo");
            esValido = false;
        }

        if (entidadTarea.CausalEmergenciaId === 0 && entidadTarea.TipoServicioId === EnumTipoTarea.Emergencia) {
            agregarError("CausalEmergenciaId", "Selecciona una causal de emergencia");
            esValido = false;
        }

        const equipo = entidadesTarea.Equipos.find(e => e.Id === entidadTarea.EquipoId);
        if (equipo?.EstadoEquipoId === EnumEstadoEquipo.EquipoEnMora && entidadTarea.TipoServicioId !== EnumTipoTarea.Emergencia && entidadTarea.TipoServicioId !== EnumTipoTarea.Correctivo && entidadTarea.TipoServicioId !== EnumTipoTarea.Acompanamiento) {
            validacionTipoEquipoTipoTarea = false;
        }



        if (!esValido) {
            mostrarNotificacion(
                EnumTipoNotificacion.Warning,
                "Campos requeridos (*)",
                "Por favor completa todos los campos antes de continuar.",
                5000
            );
        }

        if (!fechaValida) {
            mostrarNotificacion(
                EnumTipoNotificacion.Warning,
                "Fecha Invalida",
                "Selecciona una fecha y hora iguales o posteriores a la actual.",
                5000
            );
        }

        if (!validacionTipoEquipoTipoTarea) {
            mostrarNotificacion(
                EnumTipoNotificacion.Warning,
                "Advertencia",
                "El equipo seleccionado se encuentra en mora, solo se pueden crear tareas de tipo \"Emergencia\", \"Correctivo\" o \"Acompañamiento\".",
                5000
            )
        }



        return esValido && fechaValida && validacionTipoEquipoTipoTarea && validacionPerfilUsuarioLoggeado;
    };


    const crearTarea = async () => {

        try {
            manejarCargando(true, undefined, true);
            const tareaParaCrear = {
                ...entidadTarea,
                Id: undefined,
                ModulosChecklist: undefined,
                EstadoTareaId: EnumEstadoTarea.Creada,
                CreadaPor: usuario?.Id || 0, 
                CausalEmergenciaId: entidadTarea.CausalEmergenciaId === 0 ? null : entidadTarea.CausalEmergenciaId
            };
            const tareaRespuesta = await modeloTarea.crearTarea(convertirFormularioATarea(tareaParaCrear));
            const tareaId = tareaRespuesta.Data.Id;
            if (tareaRespuesta.NotificationType === EnumTipoNotificacion.Success && tareaRespuesta.Data && tareaId && entidadTarea.ModulosChecklist) {
                const respuesta = await modeloModuloTarea.crearModulosTarea({
                    IdTarea: tareaId,
                    IdModuloCatalogos: entidadTarea.ModulosChecklist
                })
                if (respuesta.NotificationType === EnumTipoNotificacion.Success) {
                    abrirModalTarea(false, null);
                } else {
                    mostrarNotificacion(
                        EnumTipoNotificacion.Error,
                        'Error al asociar modulos a la tarea',
                        'La tarea se creo correctamente, pero no se pudieron asociar los módulos. Por favor verifica tu conexión e intenta nuevamente.',
                        5000
                    );
                }
                consultarTareas()
                setEntidadTarea({ ...entidadTarea, Id: tareaId })
            }
            if (tareaRespuesta.Messages.length > 0) {
                tareaRespuesta.Messages.forEach(mensaje =>
                    mostrarNotificacion(
                        tareaRespuesta.NotificationType,
                        '',
                        mensaje,
                        4000
                    ));
            }

        }
        catch {
            mostrarNotificacion(
                EnumTipoNotificacion.Error,
                'Error al crear tarea',
                'No fue posible crear el tarea. Por favor verifica tu conexión e intenta nuevamente.',
                5000
            );
        } finally {
            manejarCargando(false);
        }
    }

    const editarTarea = async () => {
        manejarCargando(true, undefined, true);

        try {
            // 1️⃣ Editar tarea
            const tareaRespuesta = await modeloTarea.editarTarea({
                ...entidadTarea,
                Equipo: undefined,
                TipoTarea: undefined,
                UsuarioAsignado: undefined,
                ModulosChecklist: []
            });

            if (tareaRespuesta.Messages?.length) {
                tareaRespuesta.Messages.forEach(mensaje =>
                    mostrarNotificacion(
                        tareaRespuesta.NotificationType,
                        '',
                        mensaje,
                        4000
                    )
                );
            }

            if (tareaRespuesta.NotificationType !== EnumTipoNotificacion.Success) {
                return;
            }

            // 2️⃣ Obtener módulos de la tarea
            let modulosTarea;
            try {
                modulosTarea = await modeloModuloTarea.obtenerListaModulosTarea(entidadTarea.Id!);
            } catch {
                mostrarNotificacion(
                    EnumTipoNotificacion.Error,
                    'Error al consultar módulos',
                    'No fue posible obtener los módulos de la tarea.',
                    5000
                );
                return;
            }

            // 3️⃣ Asociar / actualizar módulos
            try {
                let respuesta;

                if (modulosTarea.Data?.length && entidadTarea.ModulosChecklist) {
                    respuesta = await modeloModuloTarea.actualizarModulosTarea({
                        Id: modulosTarea.Data[0].Id,
                        IdTarea: entidadTarea.Id!,
                        IdModuloCatalogos: entidadTarea.ModulosChecklist
                    });
                } else {
                    respuesta = await modeloModuloTarea.crearModulosTarea({
                        IdTarea: entidadTarea.Id!,
                        IdModuloCatalogos: entidadTarea.ModulosChecklist || []
                    });
                }

                if (respuesta.NotificationType === EnumTipoNotificacion.Success) {
                    abrirModalTarea(false, null);
                } else {
                    mostrarNotificacion(
                        EnumTipoNotificacion.Error,
                        'Error al asociar módulos',
                        'La tarea se actualizó correctamente, pero no se pudieron asociar los módulos.',
                        5000
                    );
                }
            } catch {
                mostrarNotificacion(
                    EnumTipoNotificacion.Error,
                    'Error al asociar módulos',
                    'Ocurrió un error al asociar los módulos a la tarea.',
                    5000
                );
            }

            // 4️⃣ Refrescar tareas
            consultarTareas();

        } catch {
            mostrarNotificacion(
                EnumTipoNotificacion.Error,
                'Error al actualizar tarea',
                'No fue posible actualizar la tarea. Por favor verifica tu conexión e intenta nuevamente.',
                5000
            );
        } finally {
            manejarCargando(false);
        }
    };


    const guardarEditarTarea = async () => {
        if (!entidadTarea.Id) {
            if (!validarCamposTarea(false)) return;
            const confirmado = await confirmar({
                titulo: "Crear tarea",
                mensaje: `¿Está seguro de que desea crear la tarea?`,
                textoAceptar: "Sí, crear tarea",
                textoCancelar: "Cancelar",
                tipo: EnumTipoNotificacion.Warning,
                opcionCancelar: true
            });
            if (confirmado) {
                crearTarea();
            }
        }
        else {
            if (!validarCamposTarea(true)) return;
            const confirmado = await confirmar({
                titulo: "Editar tarea",
                mensaje: `¿Está seguro de que desea editar la tarea #${entidadTarea.Id}?`,
                textoAceptar: "Sí, editar tarea",
                textoCancelar: "Cancelar",
                tipo: EnumTipoNotificacion.Warning,
                opcionCancelar: true
            });

            if (confirmado) {
                editarTarea();
            }
        }
    }


    const manejarCambioValorTarea = async (
        campo: keyof ITareaFormulario,
        valor: ITareaFormulario[keyof ITareaFormulario]
    ) => {

        let efectos: (() => void | Promise<void>)[] = [];

        if (["ProyectoId", "ClienteId", "NumeroContrato", "CodigoEquipo", "EquipoId"].includes(campo as string)) {
            efectos.push(() => {
                agregarError("FechaInicio", "");
            });
        }

        setEntidadTarea(prevEstado => {

            let nuevoEstado: ITareaFormulario = { ...prevEstado, [campo]: valor };

            const esEmergencia =
                nuevoEstado.TipoServicioId === EnumTipoTarea.Emergencia;

            const modulosEmergencia = (entidadesTarea.ModulosCheckListTodos ?? [])
                .filter(m => m.Codigo.toLowerCase() === "emergencia")
                .map(m => m.Id);

            const esCorrectivo =
                nuevoEstado.TipoServicioId === EnumTipoTarea.Correctivo ||
                nuevoEstado.TipoServicioId === EnumTipoTarea.Acompanamiento;

            const modulosCliente = (entidadesTarea.ModulosCheckListTodos ?? [])
                .filter(m => m.Codigo === "MODULO_CLIENTE")
                .map(m => m.Id);

            const restaurarListas = () => {
                efectos.push(() => {
                    setEntidadesTarea(prev => ({
                        ...prev,
                        Proyectos: prev.ProyectosTodos ?? prev.Proyectos,
                        Clientes: prev.ClientesTodos ?? prev.Clientes,
                        Equipos: []
                    }));
                });
            };

            /* ===============================
               CAMBIO PROYECTO
            =================================*/

            if (campo === "ProyectoId") {

                const proyectoId = Number(valor);

                if (!proyectoId) {

                    restaurarListas();

                    return {
                        ...nuevoEstado,
                        ProyectoId: 0,
                        ClienteId: 0,
                        ContratoId: 0,
                        NumeroContrato: "",
                        EquipoId: 0,
                        ResponsableId: 0,
                        CodigoEquipo: "",
                        ModulosChecklist: esEmergencia ? modulosEmergencia : (esCorrectivo ? modulosCliente : [])
                    };
                }

                const proyecto = entidadesTarea.Proyectos.find(
                    p => p.Id === proyectoId
                );

                if (!proyecto) return nuevoEstado;

                nuevoEstado = {
                    ...nuevoEstado,
                    ClienteId: proyecto.ClienteId ?? 0,
                    NumeroContrato: proyecto.Contrato?.Numero || "",
                    EquipoId: 0,
                    AsignadaA: 0,
                    ModulosChecklist: esEmergencia ? modulosEmergencia : (esCorrectivo ? modulosCliente : [])
                };

                efectos.push(async () => {

                    if (!proyecto.ClienteId) {
                        mostrarNotificacion(
                            EnumTipoNotificacion.Warning,
                            "No hay un cliente asociado al proyecto",
                            "Por favor verifica el proyecto",
                            6000
                        );
                    }

                    if (!proyecto.ContratoId) {
                        mostrarNotificacion(
                            EnumTipoNotificacion.Warning,
                            "No hay un contrato asociado al proyecto",
                            "Por favor verifica el proyecto",
                            6000
                        );
                    }

                    const equiposRelacionados =
                        await consultarEquiposPorProyectoId(proyecto.Id);

                    const equiposFiltrados = equiposRelacionados.filter(
                        e =>
                            e.EstadoEquipoId !== EnumEstadoEquipo.SinContrato &&
                            e.EstadoEquipoId !== EnumEstadoEquipo.Suspendido
                    );

                    const tecnicosFiltrados = entidadesTarea.TecnicosTodos.filter(t =>
                        t.Activo &&
                        t.RegionalId === proyecto.Regional?.Id
                    );

                    setEntidadesTarea(prev => ({
                        ...prev,
                        Equipos: equiposFiltrados.length > 1 ? equiposFiltrados : [],
                        Tecnicos: tecnicosFiltrados
                    }));

                    if (equiposFiltrados.length === 1) {

                        const equipo = equiposFiltrados[0];

                        setEntidadTarea(prev => ({
                            ...prev,
                            Equipo: equipo,
                            EquipoId: equipo.Id,
                            CodigoEquipo: equipo.Codigo
                        }));

                    }

                });

                return nuevoEstado;
            }

            /* ===============================
               CAMBIO CLIENTE
            =================================*/

            if (campo === "ClienteId") {

                const clienteId = Number(valor);

                if (!clienteId) {

                    restaurarListas();

                    return {
                        ...nuevoEstado,
                        ClienteId: 0,
                        ProyectoId: 0,
                        ContratoId: 0,
                        NumeroContrato: "",
                        CodigoEquipo: "",
                        EquipoId: 0,
                        ResponsableId: 0,
                        ModulosChecklist: esEmergencia ? modulosEmergencia : (esCorrectivo ? modulosCliente : [])
                    };
                }

                efectos.push(() => {

                    const proyectos = (entidadesTarea.ProyectosTodos ?? [])
                        .filter(p => p.ClienteId === clienteId);

                    setEntidadesTarea(prev => ({
                        ...prev,
                        Proyectos: proyectos
                    }));

                    if (proyectos.length === 0) {

                        mostrarNotificacion(
                            EnumTipoNotificacion.Warning,
                            "No hay proyectos asociados al cliente",
                            "Por favor verifica",
                            6000
                        );

                    }

                });

                return nuevoEstado;
            }

            /* ===============================
               CAMBIO EQUIPO
            =================================*/

            if (campo === "EquipoId") {

                const equipo = entidadesTarea.Equipos
                    .find(e => e.Id === Number(valor));

                if (!equipo) {

                    return {
                        ...nuevoEstado,
                        EquipoId: 0,
                        ModulosChecklist: esEmergencia ? modulosEmergencia : (esCorrectivo ? modulosCliente : [])
                    };
                }

                nuevoEstado = {
                    ...nuevoEstado,
                    ModulosChecklist: esEmergencia ? modulosEmergencia.map(m => m) : (esCorrectivo ? modulosCliente.map(m => m) : []),
                    CodigoEquipo: equipo.Codigo
                };

                efectos.push(() => {

                    if (!esEmergencia && !esCorrectivo) {
                        const tipoEquipo =
                            equipo.TipoEquipoId === EnumTipoEquipo.Rampa
                                ? EnumTipoEquipo.Escalera
                                : equipo.TipoEquipoId;

                        const modulosFiltrados =
                            entidadesTarea.ModulosCheckListTodos.filter(m => {

                                if (m.Codigo === "EMERGENCIA") return false;

                                const esCliente = m.Codigo === "MODULO_CLIENTE";
                                const coincideEquipo =
                                    m.TipoEquipo === tipoEquipo;

                                return esCliente || coincideEquipo;

                            });

                        setEntidadesTarea(prev => ({
                            ...prev,
                            ModulosCheckList: modulosFiltrados
                        }));

                    }

                });

                return nuevoEstado;
            }

            /* ===============================
               CAMBIO TIPO SERVICIO
            =================================*/

            if (campo === "TipoServicioId") {

                const tipoId = Number(valor);

                if (!tipoId) {

                    return {
                        ...nuevoEstado,
                        TipoServicioId: 0,
                        ModulosChecklist: [],
                        AsignadaA: 0
                    };
                }

                // Actualizar módulos según el tipo de tarea
                if (tipoId === EnumTipoTarea.Emergencia) {
                    nuevoEstado = {
                        ...nuevoEstado,
                        ModulosChecklist: modulosEmergencia
                    };
                } else if (tipoId === EnumTipoTarea.Correctivo || tipoId === EnumTipoTarea.Acompanamiento) {
                    nuevoEstado = {
                        ...nuevoEstado,
                        ModulosChecklist: modulosCliente
                    };
                } else {
                    nuevoEstado = {
                        ...nuevoEstado,
                        ModulosChecklist: []
                    };
                }

                // Refiltrar técnicos según el tipo de tarea
                efectos.push(() => {

                    const proyectoActual = entidadesTarea.Proyectos
                        .find(p => p.Id === nuevoEstado.ProyectoId);

                    if (!proyectoActual) return;

                    const tecnicosFiltrados = entidadesTarea.TecnicosTodos.filter(t =>
                        t.Activo &&
                        t.RegionalId === proyectoActual.Regional?.Id
                    );

                    setEntidadesTarea(prev => ({
                        ...prev,
                        Tecnicos: tecnicosFiltrados
                    }));

                });

                return nuevoEstado;
            }

            return nuevoEstado;

        });

        /* ==================================
           EJECUTAR EFECTOS
        ================================== */

        for (const efecto of efectos) {
            await efecto();
        }

    };




    const agregarError = async (campo: keyof ITareaFormulario, error: string) => {
        setErrores((prevErrores) => ({
            ...prevErrores,
            [campo]: error
        }));

    }

    const consultarPorNumeroContrato = async (numero: string) => {
        try {
            manejarCargando(true, undefined, true);
            const contrato = await modeloContrato.obtenerContratoFiltros({
                NumeroContrato: numero,
                Activo: true,
                FechaFin: null,
                FechaInicio: null,
                Id: null
            });
            if (contrato.Messages.length > 0) {
                contrato.Messages.forEach(mensaje =>
                    mostrarNotificacion(
                        contrato.NotificationType,
                        '',
                        mensaje,
                        4000
                    ));
            }
            if (contrato.Data) {
                if (contrato.Data.ProyectoId) {
                    const proyecto = contrato ? entidadesTarea.Proyectos.find(p => p.Id === contrato.Data.ProyectoId) : undefined
                    if (proyecto) {
                        setEntidadTarea({
                            ...entidadTarea,
                            ProyectoId: proyecto ? proyecto.Id : 0,
                            ClienteId: proyecto && proyecto.ClienteId ? proyecto.ClienteId : 0,
                            ModulosChecklist: entidadTarea.TipoServicioId === EnumTipoTarea.Emergencia
                                ? (entidadesTarea.ModulosCheckListTodos ?? []).filter(m => m.Codigo.toLowerCase() === 'emergencia').map(m => m.Id)
                                : (entidadTarea.TipoServicioId === EnumTipoTarea.Correctivo || entidadTarea.TipoServicioId === EnumTipoTarea.Acompanamiento ? (entidadesTarea.ModulosCheckListTodos ?? []).filter(m => m.Codigo === 'MODULO_CLIENTE').map(m => m.Id) : [])
                        })

                        consultarEquiposPorProyectoId(proyecto.Id).then((equiposRelacionados) => {
                            const tecnicosFiltrados = entidadesTarea.TecnicosTodos.filter(t =>
                                t.Activo &&
                                t.RegionalId === proyecto.Regional?.Id
                            );

                            const equiposFiltrados = equiposRelacionados.filter(e => e.EstadoEquipoId !== EnumEstadoEquipo.SinContrato && e.EstadoEquipoId !== EnumEstadoEquipo.Suspendido);
                            setEntidadesTarea((prev) => ({
                                ...prev,
                                Equipos: equiposFiltrados.length > 1 ? equiposFiltrados : [],
                                Tecnicos: tecnicosFiltrados,
                            }));

                            if (equiposFiltrados.length === 0) {
                                setEntidadTarea((prev) => ({
                                    ...prev,
                                    EquipoId: 0,
                                    CodigoEquipo: '',
                                }));

                                mostrarNotificacion(
                                    EnumTipoNotificacion.Warning,
                                    'No hay equipos asociados al proyecto',
                                    'Por favor verifica el proyecto',
                                    6000
                                );
                            }

                            // Si hay solo un equipo, seleccionarlo automáticamente
                            if (equiposFiltrados.length === 1) {
                                setEntidadTarea((prev) => ({
                                    ...prev,
                                    Equipo: equiposFiltrados[0],
                                    EquipoId: equiposFiltrados[0].Id,
                                    CodigoEquipo: equiposFiltrados[0].Codigo,
                                    ModulosChecklist: prev.TipoServicioId === EnumTipoTarea.Emergencia
                                        ? (entidadesTarea.ModulosCheckListTodos ?? []).filter(m => m.Codigo.toLowerCase() === 'emergencia').map(m => m.Id)
                                        : (prev.TipoServicioId === EnumTipoTarea.Correctivo || prev.TipoServicioId === EnumTipoTarea.Acompanamiento ? (entidadesTarea.ModulosCheckListTodos ?? []).filter(m => m.Codigo === 'MODULO_CLIENTE').map(m => m.Id) : [])
                                }));
                                agregarError("EquipoId", "");
                                // 1. Definimos qué equipo estamos buscando
                                const tipoEquipoRelacionados = equiposFiltrados[0].TipoEquipoId === EnumTipoEquipo.Rampa
                                    ? EnumTipoEquipo.Escalera
                                    : equiposFiltrados[0].TipoEquipoId;

                                // 2. Aplicamos el filtro inteligente
                                const modulosFiltrados = entidadesTarea.ModulosCheckListTodos.filter(modulo => {

                                    // REGLA 1: Si es el módulo de EMERGENCIA, nunca se debe listar (false)
                                    // Cambia 'Emergencia' por el ID o nombre exacto que tenga en tu base de datos
                                    if (modulo.Codigo === 'EMERGENCIA') {
                                        return false;
                                    }

                                    // REGLA 2: Si es el módulo de CLIENTE, siempre se debe listar (true)
                                    const esModuloCliente = modulo.Codigo === 'MODULO_CLIENTE';

                                    // REGLA 3: Si coincide con el tipo de equipo seleccionado (true)
                                    const coincideConEquipo = modulo.TipoEquipo === tipoEquipoRelacionados;

                                    return esModuloCliente || coincideConEquipo;
                                });
                                setEntidadesTarea((prev) => ({
                                    ...prev,
                                    ModulosCheckList: modulosFiltrados,
                                }))
                            }
                        });
                    }
                    else {
                        mostrarNotificacion(
                            EnumTipoNotificacion.Warning,
                            'No hay un proyecto asociado al número de contrato',
                            'Por favor verifica',
                            6000
                        );
                    }



                    if (contrato && contrato.Data.Id) {
                        agregarError('NumeroContrato', '');
                        agregarError('FechaInicio', '');
                    } else {
                        mostrarNotificacion(
                            EnumTipoNotificacion.Warning,
                            'No existe un contrato con el número ingresado',
                            'Por favor verifica',
                            6000)
                    }
                    if (proyecto && proyecto.ClienteId) {
                        agregarError('ClienteId', '')
                    } else {
                        mostrarNotificacion(
                            EnumTipoNotificacion.Warning,
                            'No hay un cliente asociado al proyecto',
                            'Por favor verifica el proyecto',
                            6000)
                    }
                    if (proyecto && proyecto.Id) agregarError('ProyectoId', '')
                }

            }
            else {
                setEntidadTarea((prev) => ({
                    ...prev,
                    ProyectoId: 0,
                    ClienteId: 0,
                    EquipoId: 0,
                    CodigoEquipo: '',
                    ModulosChecklist: entidadTarea.TipoServicioId === EnumTipoTarea.Emergencia
                        ? (entidadesTarea.ModulosCheckListTodos ?? []).filter(m => m.Codigo.toLowerCase() === 'emergencia').map(m => m.Id)
                        : (entidadTarea.TipoServicioId === EnumTipoTarea.Correctivo || entidadTarea.TipoServicioId === EnumTipoTarea.Acompanamiento ? (entidadesTarea.ModulosCheckListTodos ?? []).filter(m => m.Codigo === 'MODULO_CLIENTE').map(m => m.Id) : [])
                }));

                setEntidadesTarea((prev) => ({
                    ...prev,
                    Equipos: []
                }));
                mostrarNotificacion(
                    EnumTipoNotificacion.Warning,
                    'El contrato si existe, pero no está asociado a ningún proyecto',
                    'Por favor verifica el número de contrato ingresado o contacta al administrador.',
                    6000
                );
            }
        }
        catch {
            mostrarNotificacion(
                EnumTipoNotificacion.Error,
                'Error al consultar contrato',
                'No fue posible consultar el contrato. Por favor verifica tu conexión e intenta nuevamente.',
                5000
            );
        }
        finally {
            manejarCargando(false);
        }

    }

    const consultarPorCodigoEquipo = async (codigo: string) => {
        try {
            manejarCargando(true, "Buscando equipo...", true);
            const equipos = await modeloEquipo.obtenerListaEquipos({ Codigo: codigo });

            if (equipos.Messages.length > 0) {
                equipos.Messages.forEach(mensaje =>
                    mostrarNotificacion(equipos.NotificationType, '', mensaje, 4000)
                );
            }

            if (equipos.Data && equipos.Data.length > 0) {
                // 1. Tomamos el equipo encontrado
                const equipoEncontrado = equipos.Data[0];

                // 2. Verificamos si el estado es uno de los prohibidos
                const esSuspendido = equipoEncontrado.EstadoEquipoId === EnumEstadoEquipo.Suspendido;
                const esSinContrato = equipoEncontrado.EstadoEquipoId === EnumEstadoEquipo.SinContrato;

                if (esSuspendido || esSinContrato) {
                    // Extraemos el nombre desde el DTO relacionado (EstadoEquipo o similar)
                    // Usamos un fallback por si el objeto viene nulo
                    const nombreEstado = equipoEncontrado.EstadoEquipo?.Nombre || (esSuspendido ? "SUSPENDIDO" : "SIN CONTRATO");

                    mostrarNotificacion(
                        EnumTipoNotificacion.Warning,
                        'Equipo no apto para tareas',
                        `El equipo con código ${codigo} se encuentra en estado ${nombreEstado.toUpperCase()}. No es posible crear tareas para equipos en este estado.`,
                        6000
                    );
                    return; // Detenemos la ejecución
                }

                // 3. Si el estado es válido, procedemos a buscar el proyecto
                const proyecto = entidadesTarea.Proyectos.find(p => p.Id === equipoEncontrado.ProyectoId);

                if (proyecto) {
                    const equipo = equipoEncontrado;
                    // 1. Definimos qué equipo estamos buscando
                    const tipoEquipoRelacionados = equipo.TipoEquipoId === EnumTipoEquipo.Rampa
                        ? EnumTipoEquipo.Escalera
                        : equipo.TipoEquipoId;

                    // 2. Aplicamos el filtro inteligente
                    const modulosFiltrados = entidadesTarea.ModulosCheckListTodos.filter(modulo => {

                        // REGLA 1: Si es el módulo de EMERGENCIA, nunca se debe listar (false)
                        // Cambia 'Emergencia' por el ID o nombre exacto que tenga en tu base de datos
                        if (modulo.Codigo === 'EMERGENCIA') {
                            return false;
                        }

                        // REGLA 2: Si es el módulo de CLIENTE, siempre se debe listar (true)
                        const esModuloCliente = modulo.Codigo === 'MODULO_CLIENTE';

                        // REGLA 3: Si coincide con el tipo de equipo seleccionado (true)
                        const coincideConEquipo = modulo.TipoEquipo === tipoEquipoRelacionados;

                        return esModuloCliente || coincideConEquipo;
                    });

                    setEntidadesTarea((prev) => ({
                        ...prev,
                        ModulosCheckList: modulosFiltrados,
                    }));

                    setEntidadTarea((prev) => ({
                        ...prev,
                        EquipoId: equipo.Id,
                        Equipo: equipo,
                        ProyectoId: proyecto.Id,
                        ClienteId: proyecto.ClienteId || 0,
                        NumeroContrato: proyecto.Contrato?.Numero || '',
                        ModulosChecklist: entidadTarea.TipoServicioId === EnumTipoTarea.Emergencia
                            ? (entidadesTarea.ModulosCheckListTodos ?? []).filter(m => m.Codigo.toLowerCase() === 'emergencia').map(m => m.Id)
                            : (entidadTarea.TipoServicioId === EnumTipoTarea.Correctivo || entidadTarea.TipoServicioId === EnumTipoTarea.Acompanamiento ? (entidadesTarea.ModulosCheckListTodos ?? []).filter(m => m.Codigo === 'MODULO_CLIENTE').map(m => m.Id) : [])
                    }));

                    // ... resto de tu lógica de técnicos ...
                    const tecnicosFiltrados = entidadesTarea.TecnicosTodos.filter(t =>
                        t.Activo &&
                        t.RegionalId === proyecto.Regional?.Id
                    );

                    setEntidadesTarea((prev) => ({
                        ...prev,
                        Tecnicos: tecnicosFiltrados,
                        Equipos: []
                    }));

                    // Limpiamos errores de validación
                    agregarError('EquipoId', '');
                    agregarError('ClienteId', '');
                    agregarError('ProyectoId', '');
                    agregarError('FechaInicio', '');

                } else {
                    mostrarNotificacion(
                        EnumTipoNotificacion.Warning,
                        'Proyecto no encontrado',
                        `El equipo existe y está activo, pero no pudimos encontrar el proyecto ${equipoEncontrado.ProyectoId} asociado en el sistema.`,
                        6000
                    );
                }
            } else {
                mostrarNotificacion(
                    EnumTipoNotificacion.Warning,
                    'Equipo no encontrado',
                    'No se encontró ningún equipo con el código ingresado.',
                    5000
                );
            }
        }
        catch (error) {
            console.error(error);
            mostrarNotificacion(EnumTipoNotificacion.Error, 'Error', 'Error al consultar el equipo.', 5000);
        }
        finally {
            manejarCargando(false);
        }
    };

    const consultarEquiposPorProyectoId = async (proyectoId: number) => {
        try {
            manejarCargando(true, undefined, true);

            const equipos = await modeloEquipo.obtenerListaEquipos({ ProyectoId: proyectoId });
            if (equipos.Messages.length > 0) {
                equipos.Messages.forEach(mensaje =>
                    mostrarNotificacion(
                        equipos.NotificationType,
                        '',
                        mensaje,
                        4000
                    )
                );
            }

            if (equipos.Data) {
                const equiposFiltrados = equipos.Data.filter(e => e.EstadoEquipoId !== EnumEstadoEquipo.SinContrato && e.EstadoEquipoId !== EnumEstadoEquipo.Suspendido);

                // setEntidadesTarea((prev) => ({
                //     ...prev,
                //     Equipos: equiposFiltrados,
                // }));

                return equiposFiltrados;
            }

            return [];
        } catch {
            mostrarNotificacion(
                EnumTipoNotificacion.Error,
                'Error al consultar equipos',
                'No fue posible obtener la lista de equipos por proyecto. Intenta nuevamente.',
                5000
            );
            return [];
        } finally {
            manejarCargando(false);
        }
    };



    return (
        <ModalTareaVista
            abrir={estadoModal}
            abrirModalTarea={abrirModalTarea}
            guardarEditarTarea={guardarEditarTarea}
            manejarCambioValorTarea={manejarCambioValorTarea}
            entidadesRegistro={entidadesTarea}
            agregarError={agregarError}
            errores={errores}
            tareaSeleccionado={entidadTarea}
            consultarPorNumeroContrato={consultarPorNumeroContrato}
            consultarPorCodigoEquipo={consultarPorCodigoEquipo}
            visualizacion={visualizacion}
        />
    )
}

export default ModalTareaCV;